import React from 'react';
import { connect } from 'react-redux';
import './BarcodeItem.css';
import BarcodeLinear from './BarcodeLinear';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import GetFieldsForForm from '../../../Utils/Forms/GetFieldsForForm';
import QRCode from 'qrcode.react';

const BarcodeItem = (props) => {
    const { barcodeprintconfigs, forms, pages, language, config, record } =
        props;

    const printConfig =
        barcodeprintconfigs.find((cfg) => cfg.Name === config.type) || {};

    const barcode = printConfig.UseAccessionNumberForBarcode && config.selectedRecord.accessionnumber
        ? config.selectedRecord.accessionnumber
        : config.selectedRecord.barcode;

    const barcodeLabel = printConfig.DisplayCode ? barcode : ' ';

    const fieldOptions = GetFieldsForForm(
        printConfig.ReferenceForm,
        forms,
        pages
    );
    const displayFields = buildDisplayFields(
        fieldOptions,
        printConfig,
        record,
        language
    );

    return (
        <div className="barcodeitem-content" style={buildStyles(printConfig)}>
            <div
                className="barcodeitem-barcode"
                style={{ maxHeight: printConfig.MaxBarcodeHeight }}
            >
                <div
                    className={`barcodeitem-linear ${
                        printConfig.Linear ? '' : 'app-invisible'
                    }`}
                    style={{ margin: printConfig.BarcodePadding }}
                >
                    <BarcodeLinear
                        barcode={barcode}
                        barcodeLabel={barcodeLabel}
                        barcodeHeight={printConfig.LinearHeight}
                    />
                </div>

                <div
                    className={`barcodeitem-qr ${
                        printConfig.QR ? '' : 'app-invisible'
                    }`}
                    style={{ margin: printConfig.BarcodePadding }}
                >
                    <QRCode
                        value={barcode}
                        renderAs="svg"
                        size={printConfig.QRSize}
                    />
                </div>
            </div>

            {displayFields}
        </div>
    );
};

const buildDisplayFields = (fieldOptions, printConfig, record, language) => {
    return printConfig.LabelFields.split(',')
        .map((fieldName) => {
            const fieldLookupKey = fieldName.toLowerCase();
            const field =
                fieldOptions.find(
                    (f) => f.id.toLowerCase() === fieldLookupKey
                ) ||
                (fieldLookupKey === 'accessionnumber' && {
                    id: 'accessionnumber',
                    field: TranslateTag('@SpeAcc@', language),
                });

            return (
                field && (
                    <div
                        key={field.id}
                        className="barcodeitem-field"
                        style={{ fontSize: printConfig.FieldFontSize }}
                    >
                        {printConfig.SuppressFieldLabels !== true && (
                            <div
                                className="barcodeitem-fieldtitle"
                                style={{ width: printConfig.FieldNameWidth }}
                            >
                                {field.field}:
                            </div>
                        )}
                        <div className="barcodeitem-fieldvalue">
                            {record[field.id.toLowerCase()] ||
                                'Field not available!'}
                        </div>
                    </div>
                )
            );
        })
        .filter(Boolean);
};
const buildStyles = (printConfig) => {
    return {
        flexDirection: printConfig.SideBySide ? 'row' : 'column',
        marginLeft: printConfig.LeftMargin,
        marginTop: printConfig.TopMargin,
        width: printConfig.ItemWidth,
        height: printConfig.ItemHeight,
        border: printConfig.Border ? '1px #ccc solid' : '0px',
    };
};

const mapStateToProps = (state) => {
    return {
        barcodeprintconfigs: state.config.barcodeprintconfigs,
        forms: state.config.forms,
        pages: state.config.pages,
        language: state.config.language,
    };
};

export default connect(mapStateToProps)(BarcodeItem);
